import { render } from "./DataCollectionModal.vue?vue&type=template&id=7d64bd25"
import script from "./DataCollectionModal.vue?vue&type=script&lang=js"
export * from "./DataCollectionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__